<template>
  <v-card v-ripple class="rounded-card" dark :color="seen ? 'success' : ''">
    <V-container>
      <v-layout row align-center>
        <v-flex xs3>
          <v-icon :size="size">face</v-icon>
        </v-flex>
        <v-flex xs6>
          <span class="title">{{person.name}}</span>
          <br />
          <span class="subheading">{{determineIfAtExitPoint(person.status, person.time)}}</span>
          <br />
          <span v-if="person.status === 'No activity'" class="body-1">{{person.time | momentDay}}</span>
          <span v-else class="body-1">{{person.time | moment}}</span>
        </v-flex>
        <v-flex xs3>
          <v-icon :size="size">
            {{seen ? 'check' : 'highlight_off'}}
          </v-icon>
        </v-flex>
      </v-layout>
    </V-container>
  </v-card>
</template>

<script>
import moment from 'moment'
export default {
  props: ['person', 'seen', 'eventStartTime'],
  data() {
    return {
      size: 75
    }
  },
  methods: {
    onSiteCheckIcon (status) {
      let icon = 'check'
      if (status === 'Offsite' || status === 'No Activity') {
        icon = 'highlight_off'
      }
      return icon
    },
    determineIfAtExitPoint(status, time) {
      if (status !== 'Offsite') {
        return status
      }
      if (this.getSeconds(time) < this.eventStartTime.seconds) {
        return status
      }
      return 'At muster point'
    },
    getSeconds(time) {
      return Math.round(time.getTime() / 1000)
    }
  },
  filters: {
    moment: (date) => {
      return moment(date).format('h:mm:ss a')
    },
    momentDay: (date) => {
      return moment(date).format('MMMM Do YYYY')
    }
  }
}
</script>

<style scoped>
.rounded-card{
    border-radius:50px;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonCard.vue